import React from 'react';
import cx from 'classnames';
import { CSSTransition } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleDown } from '@fortawesome/pro-solid-svg-icons';
import { DropzoneInputProps, DropzoneRootProps } from 'react-dropzone-v14';

import './MediaSourceDropzone.scss';

interface Props {
  rootProps: DropzoneRootProps;
  inputProps: DropzoneInputProps;
  zoneHover: boolean;
  dropMessage: string;
  children: React.ReactNode;
}

const MediaSourceDropzone = ({
  rootProps,
  inputProps,
  zoneHover,
  dropMessage,
  children,
}: Props) => (
  <div
    {...rootProps}
    className={cx('media-source-dropzone', rootProps.className)}
  >
    <input {...inputProps} />
    {children}
    <CSSTransition in={zoneHover} classNames="fade" timeout={200} unmountOnExit>
      <div className="dropzone-dragover">
        <span className="message">
          <FontAwesomeIcon icon={faArrowAltCircleDown} className="mr-1" />
          {dropMessage}
        </span>
      </div>
    </CSSTransition>
  </div>
);

export default MediaSourceDropzone;
